import { jsx as l } from "react/jsx-runtime";
import { useRef as p, useMemo as b, useState as v, useEffect as y } from "react";
function T({
  children: e,
  headContent: o,
  bodyClassName: t
}) {
  return `
<html>
  <head>
    <style>${S}</style>
    ${o ?? ""}
    <script>
      (() => {
        function sendHeightToParent() {
          const height = document.documentElement.offsetHeight;
          window.parent.postMessage({ eventType: "height", height }, '*');
        }

        window.addEventListener("load", function() {
          // Send event when DOM nodes change.
          const observer = new MutationObserver(sendHeightToParent);
          observer.observe(document.body, { childList: true, subtree: true });

          // Send initial event on load.
          sendHeightToParent();

          // Resend event 1 second after load, just in case the observer misses something.
          setTimeout(() => sendHeightToParent(), 1000);
        });

        // Send event when window is resized.
        window.addEventListener("resize", function() {
          sendHeightToParent();
        });
      })();

      function showSandbox() {
        window.parent.postMessage({ eventType: "show" }, '*');
      }

      function hideSandbox() {
        window.parent.postMessage({ eventType: "hide" }, '*');
      }
    <\/script>
  </head>
  <body${!!t && ` class="${t}"`}>
    ${e}
  </body>
</html>
  `;
}
const S = `
/* Apply border-box model to all elements */
*, *::before, *::after {
  box-sizing: border-box;
}

/* Remove default margin */
* {
  margin: 0;
}
`;
function H({
  src: e,
  sandbox: o,
  className: t,
  initialHidden: c,
  ...m
}) {
  const i = p(null), g = b(() => {
    if (!e)
      return T(m);
  }, []), [w, d] = v(!!c);
  return y(() => {
    function a(s) {
      var h;
      const r = i.current;
      if (!r) return;
      const u = r.contentWindow;
      if (!u || u !== s.source) return;
      const n = (h = s.data) == null ? void 0 : h.eventType;
      if (typeof n == "string") {
        if (n === "height") {
          const f = s.data.height;
          if (typeof f != "number") return;
          r.style.height = f + "px";
        }
        n === "show" && d(!1), n === "hide" && d(!0);
      }
    }
    return window.addEventListener("message", a), () => window.removeEventListener("message", a);
  }, []), /* @__PURE__ */ l(
    "iframe",
    {
      src: e,
      ref: i,
      srcDoc: g,
      sandbox: o,
      className: t,
      style: {
        width: "100%",
        border: "0",
        ...w ? { display: "none" } : {}
      }
    }
  );
}
export {
  H as Sandbox,
  T as buildSandboxContent
};
